<div>
	<div class="row">
		<form #editSite="ngForm" (ngSubmit)="saveSite()">
			<div class="col-md-6">
				<app-google-map [latitude]="map.latitude" [longitude]="map.longitude" (onAddressChanged)="editTemplate.updateSiteCoords($event)"></app-google-map>
			</div>
			<div class="col-xs-6" id="left">
				<div class="boxs3">
					<h2>Add/Update Company Site Info</h2>
					<div class="panel panel-default">
						<div class="panel-heading">Site Info</div>
					</div>
					<app-site-edit #editTemplate [site]="site" [OEMsInfo]="OEMsInfo" [dealersInfo]="dealersInfo" [serviceDealersInfo]="serviceDealersInfo" [truckDealersInfo]="truckDealersInfo" [ACTusers]="ACTusers" [mode]="'admin'" [siteOwners]="siteOwners" [onNameChange]="onSiteNameChange.bind(this)" [onAddressChange]="onSiteAddressChange.bind(this)"></app-site-edit>
					<br />

					<!-- Duplicate Site Detection Alert - Uses CSS classes to control height -->
					<div [ngClass]="{'duplicate-alert-visible': showSiteMatchDropdown && similarSites.length > 0, 'duplicate-alert-hidden': !showSiteMatchDropdown || similarSites.length === 0}">
						<strong style="display: block; margin-bottom: 8px;">🚨 Duplicate Site Detected</strong>

						<!-- Dropdown and buttons at top -->
						<div class="form-group" style="margin-bottom: 8px;">
							<label style="font-weight: bold; margin-bottom: 3px; display: block; font-size: 12px;">Existing Sites:</label>
							<select class="form-control" [(ngModel)]="selectedSiteMatch" name="siteMatch" style="z-index: 1001; min-height: 35px; font-size: 12px;">
								<option [ngValue]="null">-- Select an existing site --</option>
								<option *ngFor="let site of similarSites" [ngValue]="site">
									{{ site.isCurrentSite ? '(Current) ' : '' }}{{ site.customer_name }} - {{ site.name }} ({{ site.matchType === 'address_exact' ? 'Address Match' : site.matchType === 'current_site' ? 'Current Site' : 'Name Match: ' + site.similarity + '%' }})
								</option>
								<option [ngValue]="'KEEP_ORIGINAL'">Create New Site (Override)</option>
							</select>
						</div>
						<div style="margin-bottom: 8px; display: flex; gap: 8px; flex-wrap: wrap;">
							<!-- Show different buttons based on context -->
							<button type="button" class="btn btn-sm btn-info" (click)="returnToCustomersSites()" [disabled]="!selectedSiteMatch || selectedSiteMatch === 'KEEP_ORIGINAL'">Return to Customers / Sites</button>
							<button type="button" class="btn btn-sm btn-warning" (click)="keepOriginalSiteName()" [disabled]="editSite.invalid" *ngIf="!isEditingExistingSite()">Create New Site</button>
							<button type="button" class="btn btn-sm btn-warning" (click)="keepOriginalSiteName()" [disabled]="editSite.invalid" *ngIf="isEditingExistingSite()">Create New Site (Clone)</button>
						</div>

						<!-- Explanatory text at bottom -->
						<p style="margin-bottom: 0; font-size: 12px; color: #666;">This site already exists in our system. Please select the existing site above or confirm you want to create a new one.</p>
					</div>

					<!-- Error message if duplicates exist but none selected -->
					<div [ngClass]="{'alert alert-danger': showSiteMatchDropdown && !selectedSiteMatch, 'hidden': !showSiteMatchDropdown || selectedSiteMatch}" style="margin-bottom: 10px; padding: 8px 12px; font-size: 12px;">
						<strong>⚠️ Action Required:</strong> Please select an existing site or click "Create New Site" to proceed.
					</div>

					<button type="submit" class="btn btn-primary" [disabled]="editSite.invalid || !canCreateSite">Submit</button>
					<button type="button" class="btn btn-default" (click)="goBack()">Cancel</button>
				</div>
			</div>
		</form>
	</div>
</div>
